import { useContext, useMemo } from 'react';
import AccordionContext from '../context/accordion-context';

function useOpenStatus(itemId) {
  // @ts-ignore TS(2339): Property 'openedItems' does not exist on type 'nul... Remove this comment to see the full error message
  const { openedItems } = useContext(AccordionContext);
  return useMemo(() => openedItems?.includes(itemId), [openedItems, itemId]);
}

export default useOpenStatus;
